import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ShotsList, ShotsListItem } from '../../exercise/barrage/shot';
import { ChipFeedback } from '../fill-choice';
import Spacer from '../../spacer';

const StyledShotsList = styled(ShotsList)`
    & > ::before {
        display: inline-block;
        line-height: 34px;
        content: counter(shot-counter, upper-alpha) '.';
    }
    & > ::marker {
        content: none;
    }
`;

const FeedbackContainer = styled.div`
    display: inline-flex;
    flex-direction: column;
    vertical-align: top;

    margin: 0 16px 0 16px;

    line-height: 24px;
    font-weight: normal;
`;

const BarrageFeedback = ({ exercise, answers }) => {
    let correctShots = exercise.shots.map((shot) => {
        const myOption = exercise.options.find((option) => option.id === shot.idRef);
        return { shotId: shot.id, correctId: shot.idRef, feedback: shot.feedback, text: myOption.text };
    });

    const answersWithText = answers.map((answer) => {
        const item = exercise.options.find((option) => option.id === answer.answerId);
        return {
            ...answer,
            text: item.text,
        };
    });

    const myAnswers = correctShots.map((shot) => {
        const selected = answersWithText.find((answer) => answer.shotId === shot.shotId);
        const correct = selected ? selected.answerId === shot.correctId : false;

        return {
            ...shot,
            ...selected,
            isCorrect: correct,
        };
    });

    return (
        <StyledShotsList>
            {myAnswers.map((answer, index) => (
                <ShotsListItem key={answer.shotId}>
                    <FeedbackContainer>
                        <ChipFeedback
                            index={parseInt(answer.shotId)}
                            missedAnswer={!answer.answerId}
                            text={answer.text}
                            correct={answer.isCorrect}
                            feedback={answer.feedback}
                            correctAnswer={correctShots.find((shot) => shot.shotId === answer.shotId)}
                            indentFeedback={false}
                            useIconsForValidation={true}
                        />
                    </FeedbackContainer>
                    {index < myAnswers.length - 1 && <Spacer size="regular" />}
                </ShotsListItem>
            ))}
        </StyledShotsList>
    );
};

BarrageFeedback.propTypes = {
    answers: PropTypes.array,
    exercise: PropTypes.object,
};

export default BarrageFeedback;
